(function ($, root, undefined) {

    $(function () {

        // -----------------------------------------------------------------------
        // Mobile Menu (Bootstrap 5 Offcanvas)
        // -----------------------------------------------------------------------
        var mobileMenu = {
            init: function () {
                this.offcanvasEl = document.getElementById('mobileMenuOffcanvas');
                this.toggleBtn   = document.getElementById('mobile-menu-toggle');
                this.backdrop    = document.getElementById('mobileMenuBackdrop');
                this.closeBtn    = document.getElementById('mobileMenuClose');

                if (!this.offcanvasEl || !this.toggleBtn) return;

                // Bootstrap Offcanvas instance — use existing or create
                if (typeof bootstrap !== 'undefined' && bootstrap.Offcanvas) {
                    this.bsOffcanvas = bootstrap.Offcanvas.getOrCreateInstance(this.offcanvasEl);
                }

                this.bindEvents();
            },

            /**
             * Return all focusable elements inside the offcanvas panel
             * plus the close button on the backdrop.
             */
            getFocusableEls: function () {
                var selector = 'a[href], button:not([disabled]), textarea, input, select, [tabindex]:not([tabindex="-1"])';
                var els = Array.prototype.slice.call(this.offcanvasEl.querySelectorAll(selector));
                if (this.closeBtn) {
                    els.unshift(this.closeBtn);
                }
                return els;
            },

            bindEvents: function () {
                var self = this;

                // Toggle button click — open the offcanvas
                this.toggleBtn.addEventListener('click', function () {
                    if (self.bsOffcanvas) {
                        self.bsOffcanvas.show();
                    }
                });

                // Close button on backdrop
                if (this.closeBtn) {
                    this.closeBtn.addEventListener('click', function () {
                        if (self.bsOffcanvas) {
                            self.bsOffcanvas.hide();
                        }
                    });
                }

                // Clicking the backdrop itself closes the menu
                if (this.backdrop) {
                    this.backdrop.addEventListener('click', function (e) {
                        if (e.target === self.backdrop) {
                            if (self.bsOffcanvas) {
                                self.bsOffcanvas.hide();
                            }
                        }
                    });
                }

                // Show backdrop when offcanvas opens
                this.offcanvasEl.addEventListener('show.bs.offcanvas', function () {
                    self.toggleBtn.setAttribute('aria-expanded', 'true');
                    self.toggleBtn.setAttribute('aria-label', 'Close menu');
                    if (self.backdrop) {
                        self.backdrop.classList.add('show');
                    }
                });

                // After panel is fully shown, move focus to the close button
                this.offcanvasEl.addEventListener('shown.bs.offcanvas', function () {
                    if (self.closeBtn) {
                        self.closeBtn.focus();
                    }
                });

                // Hide backdrop when offcanvas closes
                this.offcanvasEl.addEventListener('hide.bs.offcanvas', function () {
                    if (self.backdrop) {
                        self.backdrop.classList.remove('show');
                    }
                });

                // On hidden, restore toggle state and return focus
                this.offcanvasEl.addEventListener('hidden.bs.offcanvas', function () {
                    self.toggleBtn.setAttribute('aria-expanded', 'false');
                    self.toggleBtn.setAttribute('aria-label', 'Open menu');
                    self.toggleBtn.focus();
                });

                // Focus trap: includes close button on backdrop + offcanvas items
                document.addEventListener('keydown', function (e) {
                    if (!self.offcanvasEl.classList.contains('show')) return;

                    if (e.key === 'Tab') {
                        var focusable = self.getFocusableEls();
                        if (!focusable.length) return;

                        var first = focusable[0];
                        var last  = focusable[focusable.length - 1];

                        if (e.shiftKey) {
                            if (document.activeElement === first) {
                                e.preventDefault();
                                last.focus();
                            }
                        } else {
                            if (document.activeElement === last) {
                                e.preventDefault();
                                first.focus();
                            }
                        }
                    }

                    // Escape closes the menu
                    if (e.key === 'Escape' && self.bsOffcanvas) {
                        self.bsOffcanvas.hide();
                    }
                });

                // Toggle expanded class on parent <li> when submenu opens/closes
                self.offcanvasEl.addEventListener('show.bs.collapse', function (e) {
                    var li = e.target.closest('.mobile-menu__item');
                    if (li) li.classList.add('mobile-menu__item--expanded');
                });
                self.offcanvasEl.addEventListener('hide.bs.collapse', function (e) {
                    var li = e.target.closest('.mobile-menu__item');
                    if (li) li.classList.remove('mobile-menu__item--expanded');
                });

                // Auto-close when viewport passes the desktop breakpoint
                var mql = window.matchMedia('(min-width: 1200px)');
                mql.addEventListener('change', function (e) {
                    if (e.matches && self.offcanvasEl.classList.contains('show')) {
                        self.bsOffcanvas.hide();
                    }
                });
            }
        };

        jQuery(document).ready(function(){
            mobileMenu.init();
        });

    });

})(jQuery, this);
